export default __webpack_public_path__ + "static/media/search.074b6dcf.svg";